<sub-modal-shell
  title="SEECH hub"
  hint="Open an application available to your account."
  icon="dashboard-circle"
  (dismissed)="close()"
>
  @if (loading) {
    <!-- The tiles it is about to become, in outline, so the modal does not
         resize under the pointer when the list lands. -->
    <div class="hub-grid" aria-hidden="true">
      @for (tile of skeletons; track $index) {
        <div class="hub-tile hub-tile--ghost">
          <seech-placeholder width="2.75rem" height="2.75rem" borderRadius="12px"></seech-placeholder>
          <div class="hub-tile__text">
            <seech-placeholder width="7rem" height="0.85rem" borderRadius="6px"></seech-placeholder>
            <seech-placeholder width="100%" height="0.7rem" borderRadius="6px"></seech-placeholder>
          </div>
        </div>
      }
    </div>
    <p class="hub-sr-only" role="status">Loading applications</p>
  } @else if (failed) {
    <div class="hub-state" role="alert">
      <span class="hub-state__icon hub-state__icon--warn" aria-hidden="true">
        <i sch-icon="warning"></i>
      </span>
      <p class="hub-state__title">Applications could not be loaded</p>
      <p class="hub-state__text">Check your connection, then try again.</p>
      <button
        sch-button
        type="button"
        variant="outline"
        color="primary"
        (click)="load()"
      >
        Try again
      </button>
    </div>
  } @else if (!items.length) {
    <div class="hub-state">
      <span class="hub-state__icon" aria-hidden="true">
        <i sch-icon="inbox"></i>
      </span>
      <p class="hub-state__title">No applications available</p>
      <p class="hub-state__text">Your account does not have access to any applications yet.</p>
    </div>
  } @else {
    <ul class="hub-grid" aria-label="Available SEECH applications">
      @for (item of items; track item.key) {
        <li class="hub-tile" [class.hub-tile--current]="isCurrent(item)">
          <span class="hub-tile__icon" aria-hidden="true">
            <i [sch-icon]="icon(item)"></i>
          </span>

          <span class="hub-tile__text">
            <span class="hub-tile__name">{{ item.name }}</span>
            @if (blurb(item)) {
              <span class="hub-tile__desc">{{ blurb(item) }}</span>
            }
          </span>

          @if (isCurrent(item)) {
            <span class="hub-tile__here">
              <i sch-icon="checkmark" aria-hidden="true"></i>
              Current
            </span>
          } @else {
            <!-- A real link rather than a scripted navigation: the browser then
                 supplies middle-click, ctrl-click and the context menu for free,
                 and the tile keeps working if scripting is unavailable. It is
                 stretched over the tile in CSS, so the whole tile is the target
                 while the new-tab control beside it stays separately clickable. -->
            <a
              class="hub-tile__go"
              [href]="item.url"
              [attr.aria-label]="'Open ' + item.name"
            ></a>
            <a
              class="hub-tile__new"
              [href]="item.url"
              target="_blank"
              rel="noopener noreferrer"
              [attr.aria-label]="'Open ' + item.name + ' in a new tab'"
            >
              <i sch-icon="arrow-diagonal" aria-hidden="true"></i>
            </a>
          }
        </li>
      }
    </ul>
  }
</sub-modal-shell>
